import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useCart() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/cart/add-items`, parameters).then(parseSuccessResponseData),
        });
    }

    function useListByProjectId() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.get(`/v1/cart/list/${params.ProjectId}`).then(parseSuccessResponseData),
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (params: any) => axiosPrivate.post(`/v1/cart/update`, params).then(parseSuccessResponseData),
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.delete(`/v1/cart/delete/${params.Id}`).then(parseSuccessResponseData),
        });
    }

    return { useCreate, useListByProjectId, useUpdate, useDelete };
}
